import { render, staticRenderFns } from "./GoogleDrivePlayer.vue?vue&type=template&id=481ca10f&scoped=true&"
import script from "./GoogleDrivePlayer.vue?vue&type=script&lang=js&"
export * from "./GoogleDrivePlayer.vue?vue&type=script&lang=js&"
import style0 from "./GoogleDrivePlayer.vue?vue&type=style&index=0&id=481ca10f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481ca10f",
  null
  
)

export default component.exports